<template>
  <div class="user-mgt-page">
    <div class="global-header-wrap">
      <span>{{ $t('user.users') }}</span>
      <div>
        <template v-if="$route.query.editId">
          <button class="global-button-style" @click="setSyncChannels('add')">
            设置为客服权限
          </button>
          <button
            class="global-button-style"
            @click="setSyncChannels('remove')"
          >
            取消客服权限
          </button>
        </template>
        <button class="global-button-style" @click="$router.back()">
          {{ $t('commonMsg.back') }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          @submit.native.prevent
          label-width="90px"
          class="global-page-form"
        >
          <el-form-item :label="$t('user.name')" prop="name">
            <el-input
              type="text"
              :value="ruleForm.name"
              :placeholder="$t('user.name')"
              disabled
              v-if="hasName"
            ></el-input>
            <el-input
              type="text"
              v-model="ruleForm.name"
              :placeholder="$t('user.name')"
              v-else
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.password')" prop="password">
            <el-input
              v-model="ruleForm.password"
              autocomplete="new-password"
              type="password"
              :placeholder="$t('user.password')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.nickname')" prop="nickname">
            <el-input
              v-model="ruleForm.nickname"
              :placeholder="$t('user.nickname')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.role')" prop="role_id">
            <el-select
              v-model="ruleForm.role_id"
              :placeholder="$t('placeholder.role')"
            >
              <el-option
                v-for="item in roleOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权限" prop="role_id">
            <el-select
              v-model="ruleForm.userPowerRole"
              :placeholder="$t('placeholder.role')"
            >
              <el-option
                v-for="item in powerRoleOptions"
                :key="item._id"
                :label="item.userPowerRole"
                :value="item.userPowerRole"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('user.selectOrg')" prop="fid">
            <el-tag
              v-for="tag in orgArr"
              :key="tag.id"
              closable
              @close="closeOrg(tag)"
            >
              {{ tag.name }}
            </el-tag>
            <span class="user-mgt-select-org" @click="addOrg">{{
              $t('user.select')
            }}</span>
          </el-form-item>
          <el-form-item label="手机区号">
            <el-input
              v-model="ruleForm.area_code"
              placeholder="手机区号"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.phone')">
            <el-input
              v-model="ruleForm.phone"
              :placeholder="$t('user.phone')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.email')">
            <el-input
              v-model="ruleForm.email"
              :placeholder="$t('user.email')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('org.selectArea')">
            <Area @areaHandle="areaHandle" :selectedArr="selectedArr" />
          </el-form-item>
          <el-form-item :label="$t('user.remark')" prop="remark">
            <el-input type="textarea" v-model="ruleForm.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <button class="global-button-style" @click="submitForm('ruleForm')">
              {{ $t('commonMsg.save') }}
            </button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <transition name="fade">
      <appendPopup
        v-if="appendPopup"
        :title="$t('org.addOrg')"
        @getSelection="getSelection"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Area from '@/components/area'
import appendPopup from '@/components/appendPopup'

export default {
  name: 'AddUser',
  components: {
    Area,
    appendPopup
  },
  computed: {
    ...mapGetters(['appendPopup']),
    rules() {
      let loginValidate = (rule, value, callback) => {
        if (this.$route.query.editId) return callback()
        if (!value) return callback(new Error(this.$t('verify.userName')))
        this.$http
          .verifyLoginName({ name: this.ruleForm.name })
          .then((res) => {
            res.data
              ? callback(new Error(this.$t('verify.userNameExist')))
              : callback()
          })
          .catch(() => {
            callback(new Error('请求失败'))
          })
      }
      let rules = {
        name: [{ required: true, validator: loginValidate, trigger: 'blur' }],
        nickname: [
          { required: true, message: this.$t('verify.user'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.$t('verify.phone'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('verify.email'), trigger: 'blur' }
        ],
        area_code: [
          { required: true, message: '内容不能为空', trigger: 'blur' }
        ],
        password: [
          {
            required: !this.$route.query.editId,
            message: this.$t('verify.password'),
            trigger: 'blur'
          }
        ],
        role_id: [
          {
            required: true,
            message: this.$t('verify.userRole'),
            trigger: 'change'
          }
        ]
        // fid: [{required: true, message: '请选择机构', trigger: 'change'}]
      }
      return rules
    }
  },
  data() {
    return {
      ruleForm: {
        name: null,
        nickname: null,
        area_code: null,
        phone: null,
        email: null,
        password: null,
        role_id: null,
        // fid: '',
        userPowerRole: null,
        remark: null
      },
      area: null,
      orgArr: [],
      orgIds: [],
      selectedArr: [],
      roleOptions: [],
      powerRoleOptions: [],
      orgOptions: [],
      hasName: false
    }
  },
  methods: {
    async setSyncChannels(action) {
      const channls = {
        action,
        userId: this.$route.query.editId,
        channels: ['onyx_admin']
      }
      this.$http.updateSyncChannels(channls)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.area) {
            let tempArea = {
              province: this.area[0],
              city: this.area[1],
              area: this.area[2]
            }
            Object.assign(this.ruleForm, tempArea)
          }
          this.$route.query.editId
            ? this.updateUsers(this.$route.query.editId)
            : this.addUsers()
        } else {
          return false
        }
      })
    },

    getRoles() {
      this.$http
        .getRoles()
        .then((res) => {
          this.roleOptions = res.data.rows
        })
        .catch(() => {})
    },
    getPowerRolesList() {
      this.$http
        .getPowerRolesList()
        .then((res) => {
          this.powerRoleOptions = res.data.results
        })
        .catch(() => {})
    },

    addUsers() {
      this.ruleForm.orgs = this.orgIds
      this.$http
        .addUsers(this.ruleForm)
        .then((res) => {
          this.$router.back()
          this.$message({
            type: 'success',
            message: this.$t('alertMsg.addSuccess')
          })
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: this.$t('alertMsg.addFailure')
          })
        })
    },

    updateUsers(id) {
      if (this.ruleForm.password === '******') {
        delete this.ruleForm.password
      }
      this.ruleForm.orgs = this.orgIds
      this.$http
        .updateUsers(id, this.ruleForm)
        .then((res) => {
          this.$router.back()
          this.$message({
            type: 'success',
            message: this.$t('alertMsg.editSuccess')
          })
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: this.$t('alertMsg.editFailure')
          })
        })
    },

    // getOrgList(){
    //     this.$http.getOrgList()
    //     .then(res => {
    //         this.orgOptions = res.data.rows
    //     })
    //     .catch(() => {})
    // },

    addOrg() {
      this.$store.dispatch('hasData', this.orgIds)
      this.$store.commit('windowHandle', 'appendPopup')
    },

    closeOrg(org) {
      let idx = this.orgIds.indexOf(org.id)
      this.orgArr.splice(idx, 1)
      this.orgIds.splice(idx, 1)
    },

    getSelection(selection) {
      this.orgArr = [...this.orgArr, ...selection.data]
      this.orgIds = [...this.orgIds, ...selection.ids]
    },

    resetForm() {
      Object.assign(this.ruleForm, {
        name: null,
        nickname: null,
        area_code: null,
        phone: null,
        email: null,
        password: null,
        role_id: null,
        userPowerRole: null,
        remark: null
      })
      this.area = null
      this.orgArr = []
      this.orgIds = []
      this.selectedArr = []
      this.hasName = false
    },

    getSingleUsers(id) {
      if (!id) return
      this.$http
        .getSingleUsers(id)
        .then((res) => {
          const rawData = res.data || {}
          const tempData = rawData.data || rawData.dataValues || rawData
          const orgs = tempData.orgs || tempData.Orgs || []
          const formData = {
            ...this.ruleForm,
            ...tempData,
            password: '******',
            role_id:
              tempData.role_id ||
              (tempData.role && tempData.role.id) ||
              (tempData.Role && tempData.Role.id) ||
              null,
            area_code: tempData.area_code || tempData.areaCode || null,
            userPowerRole: tempData.userPowerRole || null,
            remark: tempData.remark || null
          }

          if (formData.province && formData.city && formData.area) {
            this.selectedArr = []
            this.selectedArr.push(formData.province)
            this.selectedArr.push(formData.city)
            this.selectedArr.push(formData.area)
          }
          this.orgArr = orgs
          this.orgIds = orgs.map((item) => item.id)
          Object.assign(this.ruleForm, formData)
          this.hasName = !!this.ruleForm.name
        })
        .catch(() => {
          this.elMsg('获取用户信息失败', 'error')
        })
    },

    areaHandle(value) {
      this.area = value
    }
  },
  watch: {
    '$route.query.editId'(id) {
      this.resetForm()
      if (id) {
        this.getSingleUsers(id)
      }
    }
  },
  mounted() {
    this.getRoles()
    this.getPowerRolesList()
    // this.getOrgList()
    if (this.$route.query.editId) this.getSingleUsers(this.$route.query.editId)
  }
}
</script>

<style lang="scss">
.user-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    height: 100%;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .user-mgt-select-org {
        color: $globalLessBGColor;
        cursor: pointer;
        font-weight: bold;
      }
      .el-form-item {
        .el-select {
          width: 100%;
        }
        .el-textarea__inner {
          height: 150px;
        }
      }
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
  }
}
</style>
